const isSameArch = (tooth1, tooth2) => {
  return tooth1.slice(0, 1) === tooth2.slice(0, 1);
};

const getQuadrant = tooth => {
  const quadrantMap = {
    UR: 1, // Upper Right
    UL: 2, // Upper Left
    LR: 3, // Lower Right
    LL: 4 // Lower Left
  };
  const quadrant = tooth.slice(0, 2);
  return quadrantMap[quadrant];
};

const getRange = (quadrant, from, to) => {
  const max = Math.max(from, to);
  const min = Math.min(from, to);

  if (quadrant === 1 || quadrant === 3) {
    return Array.from(
      { length: max - min + 1 },
      (_, i) => `${quadrant === 1 ? 'UR' : 'LR'}${max - i}`
    );
  }
  return Array.from(
    { length: max - min + 1 },
    (_, i) => `${quadrant === 2 ? 'UL' : 'LL'}${min + i}`
  );
};

const getRightSection = (fromTooth, toTooth) => {
  const fromQuadrant = getQuadrant(fromTooth);
  const toQuadrant = getQuadrant(toTooth);

  if (fromQuadrant === 1 || fromQuadrant === 3) {
    return fromTooth;
  }

  if (toQuadrant === 1 || toQuadrant === 3) {
    return toTooth;
  }

  return null;
};

const getLeftSection = (fromTooth, toTooth) => {
  const fromQuadrant = getQuadrant(fromTooth);
  const toQuadrant = getQuadrant(toTooth);

  if (fromQuadrant === 2 || fromQuadrant === 4) {
    return fromTooth;
  }

  if (toQuadrant === 2 || toQuadrant === 4) {
    return toTooth;
  }

  return null;
};

const isSameDirection = (fromTooth, toTooth) => {
  const fromQuadrant = getQuadrant(fromTooth);
  const toQuadrant = getQuadrant(toTooth);
  return fromQuadrant % 2 === toQuadrant % 2;
};

const getRanges = (fromTooth, toTooth) => {
  const fromQuadrant = getQuadrant(fromTooth);
  const toQuadrant = getQuadrant(toTooth);

  if (fromQuadrant === toQuadrant) {
    return [
      {
        quadrant: fromQuadrant,
        maxTooth: Math.max(Number(fromTooth.slice(2)), Number(toTooth.slice(2))),
        minTooth: Math.min(Number(fromTooth.slice(2)), Number(toTooth.slice(2)))
      }
    ];
  }
  const rightSection = getRightSection(fromTooth, toTooth);
  const leftSection = getLeftSection(fromTooth, toTooth);

  if (isSameArch(fromTooth, toTooth)) {
    return [
      {
        quadrant: getQuadrant(rightSection),
        maxTooth: Number(rightSection.slice(2)),
        minTooth: 1
      },
      {
        quadrant: getQuadrant(leftSection),
        maxTooth: Number(leftSection.slice(2)),
        minTooth: 1
      }
    ];
  }

  if (isSameDirection(fromTooth, toTooth)) {
    const max = Math.max(Number(fromTooth.slice(2)), Number(toTooth.slice(2)));
    const min = Math.min(Number(fromTooth.slice(2)), Number(toTooth.slice(2)));
    return [
      {
        quadrant: Math.min(fromQuadrant, toQuadrant),
        maxTooth: max,
        minTooth: min
      },
      {
        quadrant: Math.max(fromQuadrant, toQuadrant),
        maxTooth: max,
        minTooth: min
      }
    ];
  }

  return [
    {
      quadrant: 1,
      maxTooth: Number(rightSection.slice(2)),
      minTooth: 1
    },
    {
      quadrant: 2,
      maxTooth: Number(leftSection.slice(2)),
      minTooth: 1
    },
    {
      quadrant: 3,
      maxTooth: Number(rightSection.slice(2)),
      minTooth: 1
    },
    {
      quadrant: 4,
      maxTooth: Number(leftSection.slice(2)),
      minTooth: 1
    }
  ];
};

export default (fromTooth, toTooth) => {
  const ranges = getRanges(fromTooth, toTooth);
  return ranges.reduce((acc, { quadrant, maxTooth, minTooth }) => {
    return acc.concat(getRange(quadrant, minTooth, maxTooth));
  }, []);
};
